
import React, { useState } from 'react';
import { AdminLayout } from '@/components/admin/layout/AdminLayout';
import { PEOManagementHeader } from '@/components/admin/peo/header/PEOManagementHeader';
import { PEOProvidersList } from '@/components/admin/peo/PEOProvidersList';
import { PEOProviderDialog } from '@/components/admin/peo/PEOProviderDialog';
import { usePEOProviders } from '@/components/admin/peo/hooks/usePEOProviders';
import { useProviderFilters } from '@/components/admin/peo/hooks/useProviderFilters';
import DuplicateProvidersAlert from '@/components/admin/peo/DuplicateProvidersAlert';

const PEOManagementPage = () => {
  const [showDebugInfo, setShowDebugInfo] = useState(false);
  const [isProviderDialogOpen, setIsProviderDialogOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  
  const { 
    providers, 
    isLoading, 
    error, 
    refetch,
    filterProviders,
    isDeletingProvider
  } = usePEOProviders();
  
  const {
    activeFilters,
    setActiveFilters,
    hasActiveFilters
  } = useProviderFilters(
    providers,
    filterProviders,
    refetch
  );
  
  const onToggleDebugInfo = () => {
    setShowDebugInfo(!showDebugInfo);
  };

  const onAddProvider = () => {
    setSelectedProvider(null);
    setIsProviderDialogOpen(true);
  };

  const onEditProvider = (provider) => {
    setSelectedProvider(provider);
    setIsProviderDialogOpen(true);
  };

  // Initialize the needed props for the components
  const filteredProviders = providers;
  const hasFiltersActive = hasActiveFilters;
  const countAppliedFilters = () => 0;
  
  return (
    <AdminLayout>
      {providers.length > 0 && (
        <DuplicateProvidersAlert />
      )}
      
      <PEOManagementHeader 
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        providers={providers}
        onToggleDebugInfo={onToggleDebugInfo}
        refetch={refetch}
        onAddProvider={onAddProvider}
      />
      
      <div className="mt-4">
        <PEOProvidersList
          providers={filteredProviders}
          isLoading={isLoading}
          isError={!!error}
          error={error}
          onAddProvider={onAddProvider}
          onEditProvider={onEditProvider}
          isDeletingProvider={isDeletingProvider}
          showDebugInfo={showDebugInfo}
        />
      </div>
      
      <PEOProviderDialog 
        isOpen={isProviderDialogOpen} 
        onOpenChange={setIsProviderDialogOpen}
        selectedProvider={selectedProvider}
        onSuccess={refetch}
      />
    </AdminLayout>
  );
};

export default PEOManagementPage;
